// Responsive mask scaling for Elementor image widgets
jQuery(document).ready(function ($) {
  const RULES = [
    { type: 'height', selector: '.home-hero-image-mobile > img', max: 1025, min: 766, original: 775, step: 0.8 },
    { type: 'height', selector: '.home-hero-image-mobile > img', max: 766, min: 300, original: 565, step: 0.783 },
    { type: 'height', selector: '.nos-actus .gallery-even-column-desktop > img', max: 1392, min: 1025, original: 555, step: 0.462 },
    { type: 'height', selector: '.nos-actus .gallery-odd-column-desktop > img', max: 1392, min: 1025, original: 270, step: 0.229 },
    { type: 'height', selector: '.nos-actus .gallery-even-column-mobile > img', max: 1024, min: 384, original: 356, step: 0.371 },
    { type: 'height', selector: '.nos-actus .gallery-odd-column-mobile > img', max: 1024, min: 384, original: 372, step: 0.384 },
    { type: 'height', selector: '.qui-sommes-nous .gallery-even-column-desktop > img', max: 1440, min: 1025, original: 716, step: 0.517 },
    { type: 'height', selector: '.qui-sommes-nous .gallery-odd-column-desktop > img', max: 1440, min: 1025, original: 350, step: 0.256 },
    { type: 'height', selector: '.qui-sommes-nous .gallery-even-column-mobile > img', max: 1024, min: 384, original: 621, step: 0.609 },
    { type: 'height', selector: '.qui-sommes-nous .gallery-odd-column-mobile > img', max: 1024, min: 384, original: 637, step: 0.643 },
    { type: 'height', selector: '.spotlight-video-post-img > img', max: 1440, min: 1025, original: 150, step: 40 / 415 },
    { type: 'height', selector: '.spotlight-video-post-img > img', max: 1024, min: 768, original: 160, step: 0 },
    { type: 'height', selector: '.spotlight-video-post-img > img', max: 767, min: 384, original: 280, step: 150 / 383 },
    { type: 'maskScale', selector: '.nos-actus .honneur-section-background-mask', max: 1391, min: 1025, original: 1, step: 0.45 / 366 },
    { type: 'maskScale', selector: '.nos-actus .honneur-section-background-mask', max: 1024, min: 768, original: 2.2, step: 0.9 / 256 },
    { type: 'maskScale', selector: '.nos-actus .honneur-section-background-mask', max: 767, min: 384, original: 4.6, step: 3 / 337 },
    { type: 'bgPosition', selector: '.nos-actus .honneur-section-background-mask', max: 1369, min: 1025, original: 50, step: 0 },
    { type: 'bgPosition', selector: '.nos-actus .honneur-section-background-mask', max: 1024, min: 768, original: 50, step: 0 },
    { type: 'bgPosition', selector: '.nos-actus .honneur-section-background-mask', max: 767, min: 384, original: 50.1, step: 0 },
  ];

  const activeRules = RULES.filter(function (rule) {
    return $(rule.selector).length > 0;
  });

  if (activeRules.length === 0) {
    return;
  }

  function applyHeightRule($elem, winWidth, rule) {
    if (winWidth >= rule.max || winWidth <= rule.min) {
      return;
    }

    const delta = rule.max - winWidth;
    const newHeight = rule.original - delta * rule.step;

    $elem.css({ height: `${newHeight}px` });
  }

  function applyMaskScaleRule($elem, winWidth, rule) {
    if (winWidth >= rule.max || winWidth <= rule.min) {
      return;
    }

    const delta = rule.max - winWidth;
    const scaleY = rule.original + delta * rule.step;

    $elem.css({ transform: `scaleY(${scaleY})` });
  }

  function applyBgPositionRule($elem, winWidth, rule) {
    if (winWidth >= rule.max || winWidth <= rule.min) {
      return;
    }

    const delta = rule.max - winWidth;
    const newBgPosY = rule.original + delta * rule.step;

    $elem.css({ 'background-position-y': `${newBgPosY}%` });
  }

  function applyRules() {
    const winWidth = $(window).width();

    activeRules.forEach(function (rule) {
      const $elem = $(rule.selector);

      if ($elem.length === 0) {
        return;
      }

      if (rule.type === 'height') {
        applyHeightRule($elem, winWidth, rule);
      } else if (rule.type === 'maskScale') {
        applyMaskScaleRule($elem, winWidth, rule);
      } else if (rule.type === 'bgPosition') {
        applyBgPositionRule($elem, winWidth, rule);
      }
    });
  }

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyRules, 100);
  });

  applyRules();
});
